module.exports = __webpack_public_path__ + "img/ads.205d12ed.png";